import React from "react";
import { Modal, Button, Text, Stack, Box, Group } from "@mantine/core";
import { IconRocket } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import Logo from "../../common/Logo/Logo";
import { brandColors } from "../../../theme/brandTheme";
import styles from "./CompletionModal.module.css";

interface CompletionModalProps {
  opened: boolean;
  onClose: () => void;
}

export default function CompletionModal({
  opened,
  onClose,
}: CompletionModalProps) {
  const navigate = useNavigate();

  const handleContinue = () => {
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      fullScreen
      withCloseButton={false}
      padding={0}
      transitionProps={{ duration: 0 }}
      classNames={{
        content: styles.modalContent,
        body: styles.modalBody,
      }}
    >
      <Box className={styles.container}>
        {/* Background blobs */}
        <Box className={styles.backgroundBlobs}>
          <Box className={styles.rightBlob} />
        </Box>

        {/* Header */}
        <Group justify="space-between" align="center" className={styles.header}>
          <Logo variant="horizontal" size="md" />
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </Group>

        {/* Content */}
        <Stack gap="md" align="center" className={styles.content}>
          <Box className={styles.iconWrapper}>
            <IconRocket size={48} stroke={1.5} color="#101820" />
          </Box>

          <Text size="xl" fw={700} className={styles.title} ta="center">
            You're all set!
          </Text>

          <Text size="sm" c="dimmed" className={styles.subtitle} ta="center">
            Visit{" "}
            <Text
              span
              c="teal"
              td="underline"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/admin/settings/studio")}
            >
              Settings
            </Text>{" "}
            if you ever want to add more employees or services.
          </Text>

          <Button
            size="md"
            mt="xl"
            onClick={handleContinue}
            className={styles.continueButton}
            styles={{
              root: {
                backgroundColor: brandColors.teal,
                "&:hover": {
                  backgroundColor: brandColors.teal,
                },
              },
            }}
          >
            Continue
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
